import { Module, VuexModule, getModule, Mutation } from 'vuex-module-decorators';
import store from '@/store';
import { Answer as AnswerModel, User as UserModel } from '@/store/models';
import AnswerService from '@/services/AnswerService';

@Module({
	dynamic: true,
	name: 'app',
	store,
})
class App extends VuexModule {
	public showContent = true;

	@Mutation
	public setShowContent(status: boolean) {
		this.showContent = status;
	}
}

export const AppModule = getModule(App);
